import camelize from 'camelize';
import snakeize from 'snakeize';

import { isNull } from 'app/utils/validators';

const getParams = (query) => {
  if (!query) {
    return {};
  }

  return camelize(
    (/^[?#]/.test(query) ? query.slice(1) : query)
      .split('&')
      .filter((key) => key !== '')
      .reduce((params, param) => {
        const pair = param.split('=');
        const key = pair[0];
        let value = pair[1];
        // value = value.indexOf(',') > -1 ? value.split(',') : value;
        value = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        params[key] = value; // eslint-disable-line
        return params;
      }, {})
  );
};

const toParams = (obj, withQuerySymbol = false) => {
  const snakeObj = snakeize(obj);
  const query = Object.keys(snakeObj)
    .filter((key) => key !== '' && !isNull(snakeObj[key]))
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(snakeObj[key])}`
    )
    .join('&');

  if (!query) {
    return '';
  }

  return withQuerySymbol ? `?${query}` : query;
};

const getState = (history, key) => {
  if (!history.location.state) {
    return null;
  }

  return history.location.state[key];
};

export default {
  getParams,
  toParams,
  getState,
};



// WEBPACK FOOTER //
// ./src/app/utils/url.js